/**
 * Created by toomasp on 11.08.2015.
 */
"use strict"
import template from './gazetter.html';

export default ["service", "util", "config", "translator", (service, util, config, trl) => {
    function setSettlementDefault(scope) {
        if (!scope.showSettlement) return;

        if (!util.getObjectByProperty(scope.settlements, 'name', scope.address.settlement)) {
            scope.address.settlement = '';
        }
    }

    function handleMunicipalitySelection(scope) {
        if (!scope.address || !scope.address.municipality) {
            if (scope.address) {
                scope.address.municipality = '';
            }
            scope.showSettlement = false;
            return;
        }
        var selectedMunicipality = util.getObjectByProperty(scope.municipalities, 'ehak', scope.address.municipality);
        if (!selectedMunicipality) {
            if (scope.municipalities.length > 1) {
                scope.address.municipality = '';
                scope.address.municipalityName = '';
                scope.address.settlement = '';
            }
            return;
        }
        scope.settlements.splice(0, scope.settlements.length);
        scope.address.municipalityName = selectedMunicipality.name;
        if (selectedMunicipality.isCity) {
            scope.address.settlement = selectedMunicipality.name;
        } else {
            service.apiGet('address/gazetter/' + scope.address.municipality, function (data) {
                scope.settlements.push({
                    name: ''
                });
                angular.forEach(data, function (value) {
                    scope.settlements.push({
                        name: value.asustusyksus
                    });
                });
                setSettlementDefault(scope);
                scope.$apply();
            });
        }
        scope.showSettlement = !selectedMunicipality.isCity;
    }

    function handleCountySelection(scope) {
        if (!scope.address || !scope.address.county) {
            return;
        }
        scope.municipalities.splice(0, scope.municipalities.length);
        scope.settlements.splice(0, scope.settlements.length);
        service.apiGet('address/gazetter/' + scope.address.county, function (data) {
            scope.municipalities.push({
                ehak: ''
            });
            angular.forEach(data, function (value) {
                scope.municipalities.push({
                    ehak: value.omavalitusEhak,
                    name: value.omavalitus,
                    isCity: value.omavalitusLiik === 'linn'
                });
            });
            handleMunicipalitySelection(scope);
            scope.$apply();
        });
    }


    class GazetterDirective {
        restrict = 'A';
        require = '^ngModel';
        scope = {
            address: '=ngModel',
            gazetterId: '@gazetter'
        };
        replace = true;
        template = template;

        link(scope, element) {
            scope.trl = trl.translate.bind(trl);

            element = $(element);
            scope.showSettlement = false;
            scope.counties = [];
            scope.municipalities = [];
            scope.settlements = [];

            service.apiGet('address/counties', function (data) {
                angular.forEach(data, function (value) {
                    scope.counties.push({
                        ehak: value.maakondEhak,
                        name: value.maakond
                    });
                });
                scope.$apply();
            }).then(()=> {
                scope.$watch('address.county', ()=>handleCountySelection(scope));
                scope.$watch('address.municipality', ()=>handleMunicipalitySelection(scope));
            });

            element.find('input,select').change(function () {
                // manual change
                scope.address.padreId = '';
                scope.address.padreFullName = '';
                scope.$apply();
            });
        }
    }

    return new GazetterDirective();
}];


// WEBPACK FOOTER //
// ./src/ui/core/common/directives/widget/gazetter/gazetter.directive.js